









import mixin from './mixin'

export default mixin.extend({
  data() {
    return {
      tagUid: '',
    }
  },
})
